export default "__VITE_ASSET__54c11bf6__"